import { styled } from "styled-components";
import { StatusNotify } from "../../common/interfaces";


export const FirstSectionCompany = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 10px;
    gap:10px;
  
   
  }
`;


export const FilesSection = styled.div`
    display:flex;
    flex-direction:column;
    margin-top: 20px;
    gap:10px;
  
    label{
        margin-left: 15px
    }
    
   
  
`;


export const FilesSectionSelector = styled.div`
    
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
   
    label {
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 1.2rem;
    }
  
`;


export const StatusMyNotify = styled.td<StatusNotify>`
  color: ${({ status }) => (status ? 'green' : 'red')};
  font-weight: bold;
  font-size: 1.2rem;
`;
